import { render, staticRenderFns } from "./OwnerInfoDialog.vue?vue&type=template&id=81cb1b98&scoped=true&"
import script from "./OwnerInfoDialog.vue?vue&type=script&lang=js&"
export * from "./OwnerInfoDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81cb1b98",
  null
  
)

export default component.exports